import type {
  AnyCustomFieldDefinition,
  FieldsetCustomFieldDefinition,
  UploadCustomFieldDefinition,
} from '../index';
import { EMAIL_VALIDATION_REGEX } from '../constants/regex';
import type { CustomFieldHelperType } from '../types';

export const isFieldsetDefinition = (
  def: AnyCustomFieldDefinition
): def is FieldsetCustomFieldDefinition => {
  return def.type === 'fieldset';
};

export const isUploadDefinition = (
  def: AnyCustomFieldDefinition
): def is UploadCustomFieldDefinition => {
  return def.type === 'upload';
};

export const isTextareaValue = (
  value: any
): value is CustomFieldHelperType['textarea']['value'] => {
  return typeof value === 'string';
};

export const isSelectValue = (
  value: any
): value is CustomFieldHelperType['select']['value'] => {
  return typeof value === 'string';
};

export const isTextValue = (
  value: any
): value is CustomFieldHelperType['text']['value'] => {
  return typeof value === 'string';
};

export const isEmailValue = (
  value: any
): value is CustomFieldHelperType['email']['value'] => {
  const regex = new RegExp(EMAIL_VALIDATION_REGEX);

  return typeof value === 'string' && (!value || regex.test(value));
};

export const isFieldsetValue = (
  value: any
): value is CustomFieldHelperType['fieldset']['value'] => {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
};

export const isUploadValue = (
  value: any
): value is CustomFieldHelperType['upload']['value'] => {
  return (
    Array.isArray(value) &&
    value.every(
      (item) =>
        typeof item === 'object' &&
        'name' in item &&
        'url' in item &&
        'mimeType' in item
    )
  );
};
